import React from 'react'
import TransactionHistoryTable from './subcomponents/TransactionHistoryTable'
import "./index.scss"
export default function TransactionHistory() {
  return (
    <TransactionHistoryTable/>
  )
}
